import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IUsersStore } from './auth.reducer';

export const selectAuthState = createFeatureSelector<IUsersStore>('auth');
export const selectData = createSelector(selectAuthState, (state: any) => state);
